import { render } from "./UserModel.vue?vue&type=template&id=db4567b2&scoped=true"
import script from "./UserModel.vue?vue&type=script&lang=js"
export * from "./UserModel.vue?vue&type=script&lang=js"

import "./UserModel.vue?vue&type=style&index=0&id=db4567b2&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db4567b2"]])

export default __exports__